import React, { useState } from 'react'
import { HiArrowSmRight } from "react-icons/hi";

function RenderFilters({filterType , filterValue , handleFilterValueChange , packages}) {
    const[date,setDate] = useState({start_date: '' , end_date: ''});
  
  return (
    <>
        {filterType === "date" && (
          <div className="w-full pr-16 flex flex-col items-center gap-6 my-5 text-base">
          <div className="flex gap-4 ">
            <div className=" gap-2">
              <label className="text-lg font-bold">From:</label>
              <input
                type="date"
                value={filterValue.start_date}
                onChange={(e) => {
                  setDate({ ...date, start_date: e.target.value });
                }}
                name="from-date"
                placeholder="Date"
                className="w-48 bg-gx-canvas p-2 border boder-slate-300 rounded-full "
              />
            </div>
            <div className=" gap-2">
              <label className="text-lg font-bold">To:</label>
              <input
                type="date"
                value={filterValue.end_date}
                onChange={(e) => {
                  setDate({ ...date, end_date: e.target.value });
                }}
                min={date.start_date}
                name="to-date"
                placeholder="Date"
                className="w-48 bg-gx-canvas p-2 border boder-slate-300 rounded-full"
              />
            </div>
             
                          <HiArrowSmRight    onClick={() => handleFilterValueChange({date})}
                          className="cursor-pointer text-5xl text-[#1D4ED8]"/> 
           
          </div>
         
        </div>
           
        )}

        {filterType === "month" && (
            <div className='w-full text-center my-5 text-base'>
                <select name="month" 
                value={filterValue.month} 
                placeholder='Select Month' 
                onChange={(e) => {
                    handleFilterValueChange({month: e.target.value});
                }}
                className={'w-1/2 border border-gx-border bg-gx-canvas p-1 px-3 rounded-full outline-0'}
                >
                    <option value="">Select Month</option>
                    <option value="Jan">January</option>
                    <option value="Feb">February</option>
                    <option value="Mar">March</option>
                    <option value="Apr">April</option>
                    <option value="May">May</option>
                    <option value="Jun">June</option>
                    <option value="Jul">July</option>
                    <option value="Aug">August</option>
                    <option value="Sep">September</option>
                    <option value="Oct">October</option>
                    <option value="Nov">November</option>
                    <option value="Dec">December</option>
                </select>
            </div>
        )}           

            {filterType === "gender" && (
                <div className='w-full text-center my-5 text-base'>
                    <select name="gender" 
                    value={filterValue.gender} 
                    placeholder='Select Gender' 
                    onChange={(e) => {
                        handleFilterValueChange({gender: e.target.value});
                    }}
                    className={'w-1/2 border border-gx-border bg-gx-canvas p-1 px-3 rounded-full outline-0'}
                    >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                </div>
            )}
            {filterType === "package_id" && (
                <div className='w-full text-center my-5 text-base'>
                    <select name="package_id" 
                    value={filterValue.package_id} 
                    placeholder='Select Package' 
                    onChange={(e) => {
                        handleFilterValueChange({package_id: e.target.value});
                    }}
                    className={'w-1/2 border border-gx-border bg-gx-canvas p-1 px-3 rounded-full outline-0'}
                    >
                        <option value="">Select Package</option>
                        {
                            packages?.map((member_package , index) => (
                                <option key={index} value={member_package?._id}>{member_package?.title}</option>
                            ))
                        }
                    </select>
                </div>
            )}
    </>
  )
}

export default RenderFilters